import { closestCorners, rectIntersection } from "@dnd-kit/core";

import type { CollisionDetection } from "@dnd-kit/core";

/** Droppable id of the drag-to-remove pad (AddPlayersPanelContainer). */
export const REMOVAL_ZONE_ID = "sidebar-removal-zone";

/**
 * Board collision detection — COMPOSED, not replaced (SE-6554).
 *
 * Two requirements pull in opposite directions:
 * - Lane-to-lane drags need `closestCorners`. `rectIntersection` only reports a
 *   droppable the dragged rect literally OVERLAPS, so crossing the gutter, or
 *   passing a short/empty lane, resolves nothing: `isOver` drops out and the
 *   drop gap stops rendering. That is the dead cross-lane feel.
 * - The drag-to-remove pad needs `rectIntersection`. 765d1274c fixed that pad by
 *   SIZING it (320x256) so its intersection-over-union ratio beats the stage
 *   columns it overlaps — a fix that only means anything under IoU ranking.
 *   `closestCorners` ranks by corner distance, so a card dropped squarely on the
 *   visible red pad could resolve to the column beneath it and MOVE the player
 *   instead of removing them: precisely the bug that commit fixed.
 *
 * So ask `rectIntersection` first and hand the drag to the removal pad whenever
 * it is genuinely overlapped; otherwise fall back to `closestCorners` for the
 * lanes. The pad keeps its IoU priority, everything else gets nearest-droppable.
 *
 * SE-6554 item N moved this out of MainView so the composition itself is unit
 * testable — see `__tests__/boardCollisionDetection.test.ts`. The pre-existing
 * guard asserts only the pad's CLASS LIST, which a flattening back to a single
 * detector leaves green while silently re-breaking drop-to-remove.
 * @param args - dnd-kit's collision detection arguments
 * @returns The winning collisions
 */
export const boardCollisionDetection: CollisionDetection = args => {
  const removal = rectIntersection(args).find(
    ({ id }) => id === REMOVAL_ZONE_ID
  );
  return removal ? [removal] : closestCorners(args);
};
